@if (cartItemValidationError != undefined) {
  @switch (cartItemValidationError.shoppingCartItemValidationError) {
    @case (eCartItemValidationError.ProductHasExportBan) {
      <div class="invalid" i18n="@@CartValidationResultCartItemProductHasExportBan">Product has an export ban.</div>
    }
    @case (eCartItemValidationError.ProductIsInactive) {
      <div class="invalid" i18n="@@CartValidationResultCartItemProductIsInactive">Product is invalid.</div>
    }
    @case (eCartItemValidationError.ProductIsOutOfStock) {
      <div class="invalid">
        @if (shouldDisplayAvailableQuantity == true) {
          <div i18n="@@CartValidationResultCartItemProductIsOutOfStockQuantityLabel">Not enough in stock.</div>
          <div i18n="@@CartValidationResultCartItemProductIsOutOfStockQuantityDetail">{{quantity}}
            remaining</div>
        }
        @if (shouldDisplayAvailableQuantity != true) {
          <span i18n="@@CartValidationResultCartItemProductIsOutOfStock">Product is out of stock.</span>
        }
      </div>
    }
    @case (eCartItemValidationError.Unauthorized) {
      <div class="invalid" i18n="@@CartValidationResultCartItemUnauthorized">Unauthorized</div>
    }
    @case (eCartItemValidationError.SalesQuotaExceeded) {
      <div class="invalid">
        @if (cartItemValidationError.errorDetails?.availableQuantity == undefined) {
          <div i18n="@@CartValidationResultCartItemSalesQuotaExceededLabel">Exceeded sales quota.</div>
        }
        @if (cartItemValidationError.errorDetails?.availableQuantity != undefined) {
          <div i18n="@@CartValidationResultCartItemSalesQuotaExceededDetail">Maximum {{
            cartItemValidationError.errorDetails?.availableQuantity | number:"1.2-2" }} {{
            cartItemValidationError.errorDetails?.availableQuantityUnit | quantityUnitToString:false }}</div>
        }
      </div>
    }
    @default {
      <div class="invalid" i18n="@@CartValidationResultCartItemMissingEnumCaseImplementation">Cart validation error
        {{ eCartItemValidationError[cartItemValidationError.shoppingCartItemValidationError] }}</div>
    }
  }
}